import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, MailCheck } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { Field, BigButton } from "@/components/Field";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Recuperar senha" subtitle="Enviaremos um link para você criar uma nova senha.">
      {sent ? (
        <div className="text-center space-y-4" data-testid="forgot-password-success">
          <MailCheck className="h-14 w-14 mx-auto text-[#2E7D32]" />
          <p className="text-[#1B2A26]">Se o e-mail <b>{email}</b> estiver cadastrado, você receberá o link em instantes. Verifique também a caixa de spam.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <Field label="E-mail cadastrado" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          <BigButton type="submit" disabled={busy} data-testid="forgot-submit-button">
            {busy && <Loader2 className="h-5 w-5 animate-spin" />} Enviar link
          </BigButton>
        </form>
      )}
      <p className="mt-6 text-center">
        <Link to="/login" className="font-semibold text-[#1E4D2B] hover:underline" data-testid="back-to-login-link">Voltar para o login</Link>
      </p>
    </AuthLayout>
  );
}
